import React from 'react';
import PropTypes from 'prop-types';

import {Button, Box} from 'views/components';

import {translate} from 'views/module';

import NotificationStatusTag from './NotificationStatusTag';
import SubscribeUserDialog from './dialogs/SubscribeUserDialog';
import ConfirmDialog from './dialogs/ConfirmDialog';

const ClientNotification = (props) => {
  const {clientBackend, relationshipData, userNotificationEmail} = props;
  const [isLoading, setIsLoading] = React.useState(false);
  const [showDialog, setShowDialog] = React.useState(false);
  const [showConfirmDialog, setShowConfirmDialog] = React.useState(false);
  const [confirmAction, setConfirmAction] = React.useState(null);
  const [confirmDialogProps, setConfirmDialogProps] = React.useState({});
  const [email, setEmail] = React.useState(userNotificationEmail ?? '');

  React.useEffect(() => {
    setEmail(userNotificationEmail ?? '');
  }, [userNotificationEmail]);

  const createUserEmail = async (email) => {
    setIsLoading(true);
    clientBackend.notification.createUserEmail(relationshipData.relationshipRn, email, () => setIsLoading(false));
  };

  const removeUserEmail = async () => {
    setIsLoading(true);
    await clientBackend.notification.removeUserEmail(relationshipData.relationshipRn, email, () => setIsLoading(false));
  };

  const handleOpenDialog = () => {
    const emailContact = relationshipData.contacts.find((contact) => contact.type === 'Email');
    const existingEmail = emailContact ? emailContact.detail.trim() : '';
    setEmail(existingEmail);
    setShowDialog(true);
  };

  const handleConfirm = async () => {
    if (confirmAction) {
      await confirmAction();
    }
    setShowConfirmDialog(false);
  };

  const getButtonConfig = () => {
    if (userNotificationEmail) {
      return {
        text: translate('client.ClientDetail.Relationships.Notification.Unsubscribe'),
        action: () => {
          setConfirmDialogProps({
            title: translate('client.ClientDetail.Relationships.Notification.Dialogs.ConfirmUnsubscribeTitle'),
            message: translate('client.ClientDetail.Relationships.Notification.Dialogs.ConfirmUnsubscribeMessage'),
            confirmText: translate('client.ClientDetail.Relationships.Notification.Unsubscribe'),
          });
          setConfirmAction(() => removeUserEmail);
          setShowConfirmDialog(true);
        },
      };
    } else {
      return {text: translate('client.ClientDetail.Relationships.Notification.Subscribe'), action: handleOpenDialog};
    }
  };

  const buttonConfig = getButtonConfig();

  return (
    <>
      <Box sx={{display: 'flex', alignItems: 'center', justifyContent: 'space-between', paddingTop: '10px'}}>
        <Box>
          <Box sx={{display: 'flex', flexDirection: 'column', gap: 0.5}}>
            <Box sx={{fontWeight: 500, fontSize: '14px'}}>{email}</Box>
            <Box sx={{
              display: 'flex',
              alignItems: 'center',
            }}>
              <NotificationStatusTag userNotificationEmail={userNotificationEmail} />
            </Box>
          </Box>
        </Box>
        <Box sx={{display: 'flex', gap: 2}}>
          <Button
            onClick={buttonConfig.action}
            variant="contained"
            color="primary"
            disabled={isLoading}
          >
            {buttonConfig.text}
          </Button>
        </Box>
      </Box>
      {
        showDialog &&
        <SubscribeUserDialog
          open={showDialog}
          onClose={() => setShowDialog(false)}
          onSubmit={(email) => {
            createUserEmail(email);
            setShowDialog(false);
          }}
          initialEmail={email}
          isLoading={isLoading}
        />
      }
      {
        showConfirmDialog &&
        <ConfirmDialog
          open={showConfirmDialog}
          title={confirmDialogProps.title}
          message={confirmDialogProps.message}
          onCancel={() => setShowConfirmDialog(false)}
          onConfirm={handleConfirm}
          confirmText={confirmDialogProps.confirmText}
          cancelText={translate('client.ClientDetail.Relationships.Notification.Cancel')}
          isLoading={isLoading}
        />
      }
    </>
  );
};

ClientNotification.propTypes = {
  clientBackend: PropTypes.object.isRequired,
  userNotificationEmail: PropTypes.string,
  relationshipData: PropTypes.object.isRequired,
};

export default ClientNotification;
